const constants = {
    GLOBAL_BKMS_HTML: 'BKMS<sup>®</sup> System',
    GLOBAL_BKMS_TEXT: 'BKMS® System',
    contextPath: '/bkwebanon/',
    i18nBaseUrl: '/bkwebanon/app',
    imagesUrl: '/bkwebanon/bkweb-static/all',
};

export default constants;
